import React, { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Environment indicator banner for on-prem multi-environment deployments.
 * Shows a color-coded bar at the very top of the page (DEV/QA/PROD).
 * Only renders if app.environment.name is configured on the backend.
 */
const EnvironmentBanner = () => {
  const [envInfo, setEnvInfo] = useState(null);

  useEffect(() => {
    const fetchEnvInfo = async () => {
      try {
        const response = await axios.get('/api/deployment/mode');
        if (response.data?.success && response.data?.data?.environment) {
          setEnvInfo(response.data.data.environment);
        }
      } catch (err) {
        // Silently fail — banner just won't show
      }
    };
    fetchEnvInfo();
  }, []);

  if (!envInfo || !envInfo.name) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] text-center text-xs font-bold tracking-wider py-0.5 select-none"
      style={{
        backgroundColor: envInfo.color || '#3b82f6',
        color: '#ffffff',
        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
      }}
    >
      {envInfo.name}
    </div>
  );
};

export default EnvironmentBanner;
